// src/Casamento/GiovanaELucas/GiftListPage.tsx
// Página isolada — sem dependências do GRAIA ENEM ou do Ryan.

import React from 'react';
import './GiftListPage.css';

const WEDDING_DATE = '26 de setembro de 2026';
const COUPLE_NAME_1 = 'Giovana';
const COUPLE_NAME_2 = 'Lucas';

const GiftListPage: React.FC = () => {
  return (
    <div className="gl-page">
      <header className="gl-header">
        <span className="gl-header-ornament">♡</span>
        <h1 className="gl-header-couple">
          {COUPLE_NAME_1}
          <span className="gl-header-amp">&amp;</span>
          {COUPLE_NAME_2}
        </h1>
        <p className="gl-header-date">{WEDDING_DATE}</p>
        <p className="gl-header-subtitle">Lista de Presentes</p>
      </header>

      <section className="gl-intro">
        <p>
          A sua presença em nosso dia especial já é o maior presente que poderíamos receber.
          Mas se quiser nos presentear, aqui vão algumas sugestões para o nosso novo lar. ♡
        </p>
      </section>

      <footer className="gl-footer">
        <p>Com amor, {COUPLE_NAME_1} &amp; {COUPLE_NAME_2} ♡</p>
      </footer>
    </div>
  );
};

export default GiftListPage;
